import { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// Definir tipos
interface ViajeData {
  viaje: string;
  ruta: string;
  Kmascenso: string;
  Kmdescenso: string;
  pasajerosTerm: number;
  pasajerosRuta: number;
  totalRecibido: string;
}

// Datos de ejemplo para diferentes fechas
const viajesPorFecha: Record<string, ViajeData[]> = {
  "09-Marzo-2025": [
    {
      viaje: "A",
      ruta: "Med-San",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 15,
      pasajerosRuta: 26,
      totalRecibido: "$235.000",
    },
    {
      viaje: "B",
      ruta: "Med-San",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 12,
      pasajerosRuta: 20,
      totalRecibido: "$190.000",
    },
    {
      viaje: "C",
      ruta: "San-Med",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "D",
      ruta: "San-Med",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "E",
      ruta: "San-Med",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "F",
      ruta: "San-Med",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "G",
      ruta: "San-Med",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "H",
      ruta: "San-Med",
      Kmascenso: "Km 2.5",
      Kmdescenso: "Km 6.5",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
  ],
  "10-Marzo-2025": [
    {
      viaje: "I",
      ruta: "San-Med",
      Kmascenso: "06:30",
      Kmdescenso: "07:45",
      pasajerosTerm: 18,
      pasajerosRuta: 30,
      totalRecibido: "$280.000",
    },
    {
      viaje: "J",
      ruta: "San-Med",
      Kmascenso: "09:00",
      Kmdescenso: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "K",
      ruta: "San-Med",
      Kmascenso: "09:00",
      Kmdescenso: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "L",
      ruta: "San-Med",
      Kmascenso: "09:00",
      Kmdescenso: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "M",
      ruta: "San-Med",
      Kmascenso: "09:00",
      Kmdescenso: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "N",
      ruta: "San-Med",
      Kmascenso: "09:00",
      Kmdescenso: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "O",
      ruta: "San-Med",
      Kmascenso: "09:00",
      Kmdescenso: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: "P",
      ruta: "San-Med",
      Kmascenso: "09:00",
      Kmdescenso: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
  ],
  "11-Marzo-2025": [
    {
      viaje: "Q",
      ruta: "Med-San",
      Kmascenso: "07:00",
      Kmdescenso: "08:15",
      pasajerosTerm: 16,
      pasajerosRuta: 28,
      totalRecibido: "$260.000",
    },
    {
      viaje: "R",
      ruta: "Med-San",
      Kmascenso: "10:00",
      Kmdescenso: "11:15",
      pasajerosTerm: 13,
      pasajerosRuta: 24,
      totalRecibido: "$200.000",
    },
  ],
};

export default function TablePasajeros() {
  const fechas = Object.keys(viajesPorFecha);
  const [indexFecha, setIndexFecha] = useState(0);
  const fechaActual = fechas[indexFecha];
  const viajes = viajesPorFecha[fechaActual];

  // Funciones para cambiar la fecha
  const cambiarFecha = (adelante: boolean) => {
    setIndexFecha((prev) =>
      adelante ? Math.min(prev + 1, fechas.length - 1) : Math.max(prev - 1, 0)
    );
  };

  return (
    <div className="bg-white py-4 rounded-lg shadow-md w-full h-[100%] overflow-auto">
      <div className="flex flex-col h-[56px] px-4 items-start">
        <h2 className="text-[18px] font-semibold mb-2">VIAJE 3</h2>
        <p className="text-gray-600 text-sm">
          Planilla de pasajeros en ruta Viiaje 3 del vehiculo TYU-965
        </p>
      </div>

      <table className="w-full mt-4 border-collapse">
        <thead>
          <tr className="border-b bg-gray-100">
            <th className="py-4 pl-6 text-left text-[14px] text-textSubtitle font-medium">
              Pasajero
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Km Abordaje
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Km Descenso
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Precio
            </th>
          </tr>
        </thead>
        <tbody>
          {viajes.map((viaje, index) => (
            <tr key={index} className="border-b hover:bg-gray-100">
              <td className="py-[10px] pl-6 text-left text-[14px] text-textTipic font-medium">
                {viaje.viaje}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.Kmascenso}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.Kmdescenso}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.totalRecibido}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
